// Actions
export const API_RESPONSE_SUCCESS = "API_RESPONSE_SUCCESS";
export const API_RESPONSE_ERROR = "API_RESPONSE_ERROR";
export const GET_COUNTRY_CHARTS_DATA = "GET_COUNTRY_CHARTS_DATA";
export const GET_AUDIENCESMETRICS_CHARTS_DATA = "GET_AUDIENCESMETRICS_CHARTS_DATA";
export const GET_USERDEVICE_CHARTS_DATA = "GET_USERDEVICE_CHARTS_DATA";
export const GET_AUDIENCESSESSIONS_CHARTS_DATA = "GET_AUDIENCESSESSIONS_CHARTS_DATA";